var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type"},_vm._l((_vm.typeList),function(item,index){return _c('span',{key:index,class:_vm.current_type === index ? 'typeActive' : 'type_item',on:{"click":function($event){return _vm.checkoutType(index)}}},[_vm._v(_vm._s(item.title))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b80d3188","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/typebutton.vue
// module id = null
// module chunks = 